import * as Phaser from 'phaser';
import { BlindConfigModal } from '../components/BlindConfigModal';
import { BlindConfiguration } from '../types/holdem.types';

export class MenuScene extends Phaser.Scene {
    private blindConfigModal: BlindConfigModal | null = null;

    constructor() {
        super({ key: 'MenuScene' });
    }

    create(): void {
        const { width, height } = this.cameras.main;

        // Background
        const bg = this.add.graphics();
        bg.fillGradientStyle(0x1a0033, 0x1a0033, 0x4d0080, 0x4d0080, 1);
        bg.fillRect(0, 0, width, height);

        // Title
        const title = this.add.text(width / 2, height * 0.2, 'CASINO GAMES', {
            fontFamily: 'Bungee',
            fontSize: '48px',
            color: '#FFFFFF',
            stroke: '#FF00FF',
            strokeThickness: 4
        });
        title.setOrigin(0.5);

        // Subtitle
        const subtitle = this.add.text(width / 2, height * 0.3, 'Choose Your Game', {
            fontFamily: 'Orbitron',
            fontSize: '24px',
            color: '#00FFFF'
        });
        subtitle.setOrigin(0.5);

        // Slots Button
        const slotsButton = this.createGameButton(
            width / 2 - 350,
            height / 2,
            'REEL HEROES\nSLOTS',
            '80s Style Slot Machine',
            () => this.scene.start('GameScene')
        );

        // Video Poker Button
        const pokerButton = this.createGameButton(
            width / 2,
            height / 2,
            'CLASSIC\nVIDEO POKER',
            'Jacks or Better',
            () => this.scene.start('VideoPokerScene')
        );

        // Texas Hold 'em Button
        const holdemButton = this.createGameButton(
            width / 2 + 350,
            height / 2,
            'TEXAS\nHOLD \'EM',
            'No Limit Poker',
            () => this.showBlindConfigModal()
        );

        // Add glow effects
        this.tweens.add({
            targets: [slotsButton, pokerButton, holdemButton],
            alpha: 0.8,
            duration: 2000,
            yoyo: true,
            repeat: -1
        });
    }

    private createGameButton(x: number, y: number, title: string, subtitle: string, callback: () => void): Phaser.GameObjects.Container {
        const container = this.add.container(x, y);

        // Background
        const bg = this.add.graphics();
        bg.fillStyle(0x000000, 0.8);
        bg.fillRoundedRect(-150, -100, 300, 200, 20);
        bg.lineStyle(3, 0x00FFFF, 1);
        bg.strokeRoundedRect(-150, -100, 300, 200, 20);

        // Inner glow
        const innerGlow = this.add.graphics();
        innerGlow.lineStyle(1, 0xFF00FF, 0.5);
        innerGlow.strokeRoundedRect(-145, -95, 290, 190, 18);

        // Title text
        const titleText = this.add.text(0, -30, title, {
            fontFamily: 'Bungee',
            fontSize: '20px',
            color: '#FFFFFF',
            align: 'center'
        });
        titleText.setOrigin(0.5);

        // Subtitle text
        const subtitleText = this.add.text(0, 30, subtitle, {
            fontFamily: 'Orbitron',
            fontSize: '14px',
            color: '#00FFFF',
            align: 'center'
        });
        subtitleText.setOrigin(0.5);

        container.add([bg, innerGlow, titleText, subtitleText]);
        container.setInteractive(new Phaser.Geom.Rectangle(-150, -100, 300, 200), Phaser.Geom.Rectangle.Contains);

        // Hover effects
        container.on('pointerover', () => {
            bg.clear();
            bg.fillStyle(0x220044, 0.9);
            bg.fillRoundedRect(-150, -100, 300, 200, 20);
            bg.lineStyle(3, 0xFFFF00, 1);
            bg.strokeRoundedRect(-150, -100, 300, 200, 20);
        });

        container.on('pointerout', () => {
            bg.clear();
            bg.fillStyle(0x000000, 0.8);
            bg.fillRoundedRect(-150, -100, 300, 200, 20);
            bg.lineStyle(3, 0x00FFFF, 1);
            bg.strokeRoundedRect(-150, -100, 300, 200, 20);
        });

        container.on('pointerdown', callback);

        return container;
    }

    private showBlindConfigModal(): void {
        // Create and show the blind configuration modal
        this.blindConfigModal = new BlindConfigModal();
        this.blindConfigModal.show((config: BlindConfiguration) => {
            // Start the Texas Hold'em scene with the configuration
            this.scene.start('TexasHoldemScene', { blindConfig: config });
        });
    }
}